export default __webpack_public_path__ + "static/p2-e5af33d5bc00f5fe5c2a420f696f890e.png";